import React from "react";
import Header from "./components/home/Header";
import Hero from "./components/home/Hero";
import Steps from "./components/home/Steps";
import Divider from "./components/home/Divider";
import Divider2 from "./components/home/Divider2";
import Calculator from "./components/home/Calculator";
import Footer from "./components/home/Footer";

const Home = () => {
  return (
    <div className="app">
      <Hero />
      <Steps />
      <Divider />
      <Calculator />
      {/* <Divider2 /> */}
      <Footer />
    </div>
  );
};

export default Home;
